import "./App.css";
import "./App.css"
import Home from "./screen/Home";

function App() {
  return (
    <Home />
  );
}

export default App;
